import HttpFactory from '@/mixins/http.factory';
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
	name:'authenticate_outh2',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			isFormValidated:false,
            disableValidateBtn: true,
            data: null,
            client_id:null,
			auth:{}
		}
    },
    computed:{
		...mapState('mdDevops',['appData'])
	},
    created() {
        let _self=this;
		_self.init();
	},
	methods:{
		async init(){
			let _self=this;
            
            _self.loading = true;
            _self.client_id = _self.$route.params.client_id;

			_self.mondayInfo=await _self.fn().getMondayData_Child(_self.$route.params.appId,_self.$route.params.installationId,_self.$route.params.hdBoardId,_self.$route.params.hdItemId);
            
            _self.auth.userId=_self.mondayInfo.userInfo?_self.mondayInfo.userInfo.id:null;
            _self.auth.hdLoginUrl=_self.mondayInfo.credentials.hdLoginUrl;
            _self.auth.hdEmail=_self.mondayInfo.user.email;
            if(_self.$route.params.devOpsUrl){
                _self.auth.devOpsUrl = decodeURIComponent(_self.$route.params.devOpsUrl);
                
                let userDetailId = _self.auth.devOpsUrl ? parseInt(_self.auth.devOpsUrl.split('?userDetailId=')[1]) : null;
                userDetailId = isNaN(parseInt(userDetailId)) == true ? null : parseInt(userDetailId);

                _self.auth.devOpsUrl=_self.auth.devOpsUrl ? _self.auth.devOpsUrl.split('?userDetailId')[0] : '';
                _self.auth.userId=_self.$route.params.userId;
            }
            

            if (_self.client_id) {
                let authData = {
                    appId: _self.$route.params.appId, installationId: _self.$route.params.installationId, hdBoardId: _self.$route.params.hdBoardId, hdItemId: _self.$route.params.hdItemId, devOpsUrl: _self.auth.devOpsUrl,
                    userId:_self.$route.params.userId,
                    userDetailId: _self.$route.query.userDetailId?_self.$route.query.userDetailId:null,
                };
                if (!authData.userDetailId && authData.devOpsUrl) {
                    authData.userDetailId = authData.devOpsUrl ? parseInt(authData.devOpsUrl.split('?userDetailId=')[1]) : null;
                    authData.userDetailId = isNaN(parseInt(authData.userDetailId)) == true ? null : parseInt(authData.userDetailId);
                }
                
                //console.log('auth data on outh2', JSON.stringify(authData));
                sessionStorage[`md_app_Auth_usr${_self.auth.userId}`] = JSON.stringify(authData);
                document.location.href = `https://auth.monday.com/oauth2/authorize?client_id=${_self.client_id}&state=${_self.auth.userId}`
            } else {
                _self.loading = false;
                // console.log('user level auth started', _self.mondayInfo.userInfo);
                // if (_self.mondayInfo.userInfo.id > 0 && !_self.mondayInfo.userInfo.userDetailId) {
                //     alert('user level auth started');
                //     _self.userLevelAuthentication_OAuth2();
                // }
            }
            //await _self.getAppData();
            // if (_self.data && _self.data.configData && _self.data.configData.mondayConfig && _self.data.Data.message=='Unauthorized access...')
            //  {
            //     document.location.href = `https://auth.monday.com/oauth2/authorize?client_id=${_self.data.configData.mondayConfig.client_id}&state=${_self.auth.userId}`
            // }
        },
        async getAppData(){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			try{

				_self.auth.hdLoginUrl=_self.mondayInfo.credentials.hdLoginUrl;
				_self.auth.hdEmail = _self.mondayInfo.user.email;
				
				await this.$store.dispatch('mdDevops/getAppData',{auth:_self.mondayInfo.credentials});
				_self.data=_self.appData;
			}
			catch(ex){
				_self.commonErrorMsgDisp(ex);
			}
			_self.fn().showLoader(false);
			_self.setAppHeight();
			
		},
		//auth only
		checkForm: function (e,installBtnClick) {
            let _self=this;
            if(!installBtnClick){
                _self.disableValidateBtn=true;
                _self.isFormValidated=false;
            }
            
            _self.userMsg.list = [];
            _self.userMsg.type='danger';
            if (_self.auth.hdLoginUrl && _self.auth.hdToken
            && _self.auth.devOpsUrl && _self.auth.devOpsToken) {
                return true;
            }
            return;
            if (!_self.auth.hdLoginUrl) {
                _self.userMsg.list.push('monday Url is required.');
            } else if(!_self.validUrl(_self.auth.hdLoginUrl)){
                _self.userMsg.list.push('monday Url is invalid.');
            }
            if (!_self.auth.hdToken) {
                _self.userMsg.list.push('monday Token is  required.');
            }
			if (!_self.auth.hdEmail) {
                _self.userMsg.list.push('monday Email is  required.');
            } else if(!_self.validEmail(_self.auth.hdEmail)){
				_self.userMsg.list.push('monday Email is  invalid.');
			}
            if (!_self.auth.devOpsUrl) {
                _self.userMsg.list.push('Azure DevOps Url is  required.');
            }else if(!_self.validUrl(_self.auth.devOpsUrl)){
                _self.userMsg.list.push('Azure DevOps Url is invalid.');
            }
            if (!_self.auth.devOpsToken) {
                _self.userMsg.list.push('Azure DevOps Token is required.');
            }
            if(e){
                e.preventDefault();
            }
        },
        
        authenticate(e,cb){
            let _self=this;
            //if(!_self.checkForm(e)) return;
            _self.loading=true;
			_self.auth.appId=_self.mondayInfo.credentials.appId;
			_self.auth.installationId=_self.mondayInfo.credentials.installationId; 
            _self.auth.user=_self.mondayInfo.user;
            _self.auth.isDevOpsAuthOnly = true;
            var options = {
                method: 'POST',
                body: _self.auth,
                json: true,
                //url: _self.baseUrl+'authenticate_outh2',//because we just need to validate the devops credentials only here.
				url:'authenticate_outh2', //because we just need to validate the devops credentials only here.
                headers: {'Content-Type': 'application/json'}
            }; 
            _self.userMsg.type='danger';
            _self.userMsg.list=[];
            _self.isFormValidated=false;
            _self.post(options.url,options.body).then(function(response) {
                _self.loading=false;
                if(cb) cb(null,response);
                if(response.data.Data && response.data.Success){
                    _self.userMsg.type='info';
                    _self.isFormValidated=true;
                    _self.userMsg.list.push('App validated successfully.');
                    //_self.init();
					_self.sendDataToParent(response.data);
                }else{
                    _self.userMsg.list.push('App validation failed.');
                    if(response && response.data && response.data.Errors && response.data.Errors.length>0){
                        for(var i=0;i<response.data.Errors.length;i++){
                            _self.userMsg.list.push(response.data.Errors[i].Message);
                        }
                    }
                }
            },function(error){
                _self.loading=false;
                _self.userMsg.list.push('App validation failed.');
                if(error && error.response && error.response.Errors && error.response.Errors.length>0){
                    for(var i=0;i<error.response.Errors.length;i++){
                        _self.userMsg.list.push(error.response.Errors[i].Message);
                    }
                }
                if(cb) cb(error);
            });
        },

        //begins user level authentication via OAuth2
        async userLevelAuthentication_OAuth2(){
			let _self = this;
			_self.loading = true;
			let data = {
				code: _self.$route.query.code,
				region: _self.$route.query.region,
				scope: _self.$route.query.scope,
				state:_self.$route.query.state,
			};
			_self.data = data;
			if (!data.state || !data.code) {
				alert('Authorization failed. Please try again later. If the issue persists please contact at support@devopsintegration.io');
			}

			let config = sessionStorage[`md_app_Auth_usr${data.state}`] ? JSON.parse(sessionStorage[`md_app_Auth_usr${data.state}`]) : null;
			_self.auth.devOpsUrl = config.devOpsUrl;
			_self.mondayInfo = await _self.fn().getMondayData_Child(config.appId, config.installationId, config.hdBoardId, config.hdItemId);
			_self.auth.userId=data.state;
			_self.auth.hdLoginUrl = _self.mondayInfo.credentials.hdLoginUrl;
			_self.auth.code = data.code;
			
            //_self.auth.hdEmail=_self.mondayInfo.user.email;
            
			_self.loading = false;
			sessionStorage.removeItem(`md_app_Auth_usr${data.state}`);

			_self.getAccessTokenFromCodeFn(_self.auth);
		},
		getAccessTokenFromCodeFn: function (data) {
			_self.getAccessTokenFromCode(data, function (response) {
				_self.fn().showLoader(false);
				let userMsg;
				if(response.data.Success){
					userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Authorization done Successfully`]}
				}else{
					userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Authorization failed. Please try again later. If the issue persists please contact at support@devopsintegration.io`]}
				}
				_self.userMsg=userMsg;
			},function(error){ 
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		getAccessTokenFromCode:function(data,successCb,errorCb){
            var _self=this;
			
            var url = `getAccessTokenFromCode`;
            _self.fn().clearMessage();
			_self.postServerFn(url,data,successCb,errorCb);
		},
        //ends user level authentication via OAuth2
		validateEmpty:function(txt) {
            if (!txt || txt.trim() === '') {
                return false;
            } else {
                return true;
            }
        },
        validUrl: function (value) {
            return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
		//auth ends
        closeDialog(data) {
            let _self= this;
			_self.fn().close_monday_modal(data);
		},
        sendDataToParent(data) {
            let _self = this;
            _self.closeDialog(data);
		},
	}
}

